import { formatInTimeZone } from 'date-fns-tz';

import { BILLING_TIME_ZONE } from 'offer/helpers/rate-control-date';

/**
 * Is a policy's saved payment schedule out of date (#36357)? The rater computes the schedule on the
 * day it rates the offer, so the first payment date is that day. Once it's before today in billing's
 * time zone, the saved dates no longer match what autobill would charge, and the quote needs an update.
 *
 * Deliberately not `getStalePaymentScheduleDate`: that one is switched off for Branch (no rate control
 * date hold) and only reports a change the old billing rules would make. This applies to every brand,
 * whether or not the billing day is synced (#35596), and to offers rated before that change.
 *
 * Used by the payment schedule modal (#36360). The policy card itself doesn't change for it.
 */
export const isPaymentScheduleOutOfDate = (schedule, now = new Date()) => {
  const firstPaymentDate = schedule?.[0]?.date;
  if (!firstPaymentDate) {
    return false;
  }
  // AWSDate strings ('yyyy-MM-dd') sort chronologically.
  return firstPaymentDate < formatInTimeZone(now, BILLING_TIME_ZONE, 'yyyy-MM-dd');
};
